"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LaunchInfoStatus = void 0;
var LaunchInfoStatus;
(function (LaunchInfoStatus) {
    LaunchInfoStatus["OK"] = "OK";
    LaunchInfoStatus["PLAYER_NOT_FOUND"] = "PLAYER_NOT_FOUND";
    LaunchInfoStatus["INTERNAL_ERROR"] = "INTERNAL_ERROR";
    LaunchInfoStatus["LAUNCH_IS_IN_PROGRESS"] = "LAUNCH_IS_IN_PROGRESS";
    LaunchInfoStatus["RESTRICTED_COUNTRY"] = "RESTRICTED_COUNTRY";
    LaunchInfoStatus["PLAYER_IS_LOCKED"] = "PLAYER_IS_LOCKED";
    LaunchInfoStatus["INVALID_PARAMETERS"] = "INVALID_PARAMETERS";
    LaunchInfoStatus["MAINTENANCE_MODE"] = "MAINTENANCE_MODE";
    LaunchInfoStatus["GAME_ID_NOT_VALID"] = "GAME_ID_NOT_VALID";
    LaunchInfoStatus["RESTRICTED_JURISDICTION"] = "RESTRICTED_JURISDICTION";
    LaunchInfoStatus["PLAYER_IS_ONLINE"] = "PLAYER_IS_ONLINE";
    LaunchInfoStatus["PLAYER_IS_STILL_CASHED_IN"] = "PLAYER_IS_STILL_CASHED_IN";
})(LaunchInfoStatus || (exports.LaunchInfoStatus = LaunchInfoStatus = {}));
